













































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import * as service from '@/services/business-units';
import BusinessUnitModel from '@/models/business-unit-model';
import { getUFs } from '@/services/utils';
import BaseComponent from '@/components/base-component.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiFileUpload from '@/components/UI/file-upload.vue';
import { toUpperCase } from '@/helpers/toUpperCase';
import { IMAGE_MIME_TYPES } from '@/settings/consts/file-upload';
import {
  MESSAGE_FILE_ERROR_UPLOAD,
  MESSAGE_FILE_SIZE_EXCEEDED,
  MESSAGE_FILE_ERROR_DELETE,
  MESSAGE_BUSINESS_UNIT_ERROR,
} from '@/settings/consts/messages';
import {
  ERROR_CODE_FILE_SIZE_EXCEEDED,
  ERROR_CODE_BUSINESS_UNIT_DUPLICATE,
  ERROR_CODE_NOT_ACCEPTABLE,
} from '@/settings/consts/api-error';
import { cloneDeep } from 'lodash';
import { errorHandling } from '@/helpers/errorHandling';
import { validEmail } from '@/helpers/validEmail';
import { HorarioEmpresa } from '../../interfaces/business-units';

@Component({
  components: {
    PermissionAuth,
    UiFileUpload,
  },
})
export default class BusinessUnitForm extends BaseComponent {
  @Prop()
  public isEdit: boolean = false;
  @Prop()
  public editItem: any;

  public currentTab: string = 'tab-dados-empresa';

  public form: any = {
    valid: false,
    rules: {
      nomeFantasia: [(v) => !!v || 'Digite um nome fantasia válido'],
      razaoSocial: [(v) => !!v || 'Digite uma razão social válida'],      
      cnpj: [(v) => !!v || 'Digite o CNPJ'],
      cpf: [(v) => !!v || 'Digite um CPF válido'],
      telefone: [(v) => !!v || 'Digite um telefone válido'],
      endereco: [(v) => !!v || 'Digite um endereço válido'],
      cep: [(v) => !!v || 'Digite um CEP válido'],
      bairro: [(v) => !!v || 'Digite um bairro válido'],
      cidade: [(v) => !!v || 'Digite uma cidade válido'],      
      estado: [(v) => !!v || 'Digite uma UF válida'],
      nomeResponsavel: [(v) => !!v || 'Digite um nome de responsável válido'],
      cpfResponsavel: [(v) => !!v || 'Digite um cpf válido para o responsável'],
      emailResponsavel: [(v) => (!!v && validEmail(v)) || 'Digite um e-mail válido.'],
    },
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  public item: BusinessUnitModel = new BusinessUnitModel();
  public validTypes: string[] = IMAGE_MIME_TYPES;
  public ufs: any[] = [];
  public maxFileSize: number = 2000;
  public file: any = null;
  public deleteFile: boolean = false;

  @Watch('editItem')
  public onEditItemChanges(val: any) {
    this.item = new BusinessUnitModel(val);
    this.file = null;
    this.deleteFile = false;
    this.currentTab = 'tab-dados-empresa';
  }

  public saveItem(): void {
    this.$refs.form.validate();
    if (!this.form.valid) {
      this.currentTab = 'tab-dados-empresa';
      return;
    }

    this.loader.start('Salvando registro...');

    const payload = this.item.toJson();

    const callbackSuccess = () => {
      this.loader.stop();
      this.$emit('save');
    };

    const onError = (error) => {
      this.loader.stop();
      const errorMessages = {
        default: MESSAGE_BUSINESS_UNIT_ERROR,        
        [ERROR_CODE_NOT_ACCEPTABLE]:
          !!error && !!error.data ? error.data.message : MESSAGE_BUSINESS_UNIT_ERROR,
        [ERROR_CODE_BUSINESS_UNIT_DUPLICATE]:
          !!error && !!error.data ? error.data.message : MESSAGE_BUSINESS_UNIT_ERROR,
      };
      const message = errorHandling(error, errorMessages);
      this.toast.show(message, 'error');
    };

    const onErrorFile = (error, data) => {
      this.loader.stop();
      this.item = new BusinessUnitModel(data);

      const errorMessages = {
        default: MESSAGE_FILE_ERROR_UPLOAD,
      };

      let message;
      if (!!error && error.status === ERROR_CODE_FILE_SIZE_EXCEEDED) {
        message = !!error.data ? error.data : MESSAGE_FILE_SIZE_EXCEEDED;
      } else {
        message = errorHandling(error, errorMessages);
      }

      this.toast.show(message, 'error');
    };

    const onErrorDeleteFile = (error, data) => {
      this.loader.stop();
      this.item = new BusinessUnitModel(data);

      const errorMessages = {
        default: MESSAGE_FILE_ERROR_DELETE,
      };
      const message = errorHandling(error, errorMessages);
      this.toast.show(message, 'error');
    };

    if (!this.item.id) {
      service.saveBusinessUnit(payload).subscribe((data) => {
        this.$refs.form.resetValidation();
        this.loader.stop();
        this.loader.start('Salvando o arquivo...');

        if (!!this.file) {
          service
            .saveFile(data.id, {
              file: this.file,
            })
            .subscribe(callbackSuccess, (error) => {
              onErrorFile(error, data);
            });
        } else {
          callbackSuccess();
        }
      }, onError);
    } else {
      service.updateBusinessUnit(this.item.toJson()).subscribe((data) => {
        this.$refs.form.resetValidation();
        this.loader.stop();
        this.loader.start('Salvando o arquivo...');

        if (!!this.file) {
          service
            .saveFile(data.id, {
              file: this.file,
            })
            .subscribe(callbackSuccess, (error) => {
              onErrorFile(error, data);
            });
        } else if (!!this.deleteFile) {
          service.deleteFile(data.id).subscribe(callbackSuccess, (error) => {
            onErrorDeleteFile(error, data);
          });
        } else {
          this.loader.stop();
          this.$emit('save');
        }
      }, onError);
    }
  }

  public beforeMount() {
    this.getUFs();
  }

  public onRemoveFile() {
    this.deleteFile = true;
    this.item.imagem = null;
  }

  public closeForm(): void {
    const closeAction = () => {
      setTimeout(() => {
        this.$refs.form.resetValidation();
      }, 100);
      this.$emit('close');
    };

    this.dialog.show(
      'error',
      'Sair sem salvar',
      'Deseja sair sem salvar as alterações?',
      'Cancelar',
      '',
      'Sair',
      closeAction,
    );
  }

  private getUFs(): any {
    getUFs().subscribe(
      (data) => {
        this.ufs = data;
      },
      () => {
        this.toast.show('Ocorreu um erro ao carregar os UFs', 'error');
      },
    );
  }

  private onChangeHorario(horario:HorarioEmpresa) {
    if (!horario) {
      return;
    }
    if (horario.abertura && horario.abertura.length < 5) {
      horario.abertura = horario.abertura.padEnd(5, "0");
    }
    if (horario.fechamento && horario.fechamento.length < 5) {
      horario.fechamento = horario.fechamento.padEnd(5, "0");
    }
  }

  

}
